export default __webpack_public_path__ + "static/about2-284743e182e0aaf98fb5a2d572e36931.png";